import { api } from "../config/api";

export const getJobInstructions = async (jobId) => {
    const response = await api.get(`/jobs/${jobId}/instructions`);
    return response.data;
};

export const createJobInstructions = async (jobId, data) => {
    const response = await api.post(
        `/jobs/${jobId}/instructions`,
        data
    );

    return response.data;
};

export const updateJobInstructions = async (jobId, data) => {
    const response = await api.put(
        `/jobs/${jobId}/instructions`,
        data
    );

    return response.data;
};

export const deleteJobInstructions = async (jobId) => {
    await api.delete(`/jobs/${jobId}/instructions`);
};